import React from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { LogoMark } from "@/components/Logo";
import { CustomerSignup } from "@/components/CustomerSignup";

/**
 * Registration panel shown when a logged-out customer taps a service tile.
 * onSuccess(user) is called after phone verification completes.
 */
export const CustomerAuthModal = ({ open, onOpenChange, onSuccess }) => {
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 overflow-hidden gap-0" data-testid="customer-auth-modal">
        <DialogTitle className="sr-only">Create your ServeOn account</DialogTitle>
        <DialogDescription className="sr-only">Sign up with your full name and phone number to start using ServeOn.</DialogDescription>
        <div className="p-6 sm:p-7">
          <div className="flex items-center gap-2.5 mb-4">
            <LogoMark size={38} />
            <span className="font-black text-2xl tracking-tight">
              <span style={{ color: "var(--so-text)" }}>Serve</span>
              <span style={{ color: "var(--so-orange)" }}>On</span>
            </span>
          </div>
          <CustomerSignup
            onSuccess={(user) => { onOpenChange?.(false); onSuccess?.(user); }}
            onLoginClick={() => { onOpenChange?.(false); navigate("/login"); }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};
